/* eslint-disable react/button-has-type */
import React, { useState } from 'react';
import { oneOf, oneOfType, bool, string, func, node, object, element, } from 'prop-types';
import getClass from './button-class-format';
import setClass from '../../common/set-class';
import Icon from '../icon';
const getTagAndProps = ({ href, target, disabled, isDisabled, linkComponent, type, download, }) => {
    if (disabled || isDisabled || !href) {
        return { Tag: 'button', restProps: { type: type || 'button' } };
    }
    if (!target && linkComponent) {
        return { Tag: linkComponent, restProps: { to: href } };
    }
    return {
        Tag: 'a',
        restProps: { href, target, download, rel: 'noopener noreferrer' },
    };
};
const Button = (props) => {
    const { isDisabled, isActive, disabled, children, onClick, style, className, theme, size, isWide, icon, iconPlacement, isProgress, kind, innerRef, } = props;
    const [isProcessing, setIsProcessing] = useState(false);
    const theIcon = isProcessing ? 'arrows-rotate' : icon;
    const handleClick = async (event) => {
        const timeoutId = setTimeout(() => setIsProcessing(true), 100);
        try {
            await onClick(event);
        }
        catch (error) {
            console.error(error);
        }
        clearTimeout(timeoutId);
        setIsProcessing(false);
    };
    const childrenCount = React.Children.count(children);
    const klass = getClass({
        theme,
        kind,
        size,
        isWide,
        icon: theIcon,
        iconPlacement,
        childrenCount,
        isProgress: isProgress || isProcessing,
        isDisabled,
        isActive,
    });
    const { Tag, restProps } = getTagAndProps(props);
    return (React.createElement(Tag, { ref: innerRef, onClick: handleClick, className: setClass([klass, className]), style: {
            ...style,
            paddingLeft: theIcon && iconPlacement === 'left' && '8px',
            paddingRight: theIcon && iconPlacement === 'right' && '8px',
        }, disabled: isDisabled || disabled || isProgress || isProcessing, ...restProps },
        theIcon && iconPlacement === 'left' ? (React.createElement(Icon, { name: theIcon, size: size === 'large' ? 'md' : 'sm' })) : null,
        children,
        theIcon && iconPlacement === 'right' ? (React.createElement(Icon, { name: theIcon, size: size === 'large' ? 'md' : 'sm' })) : null));
};
Button.propTypes = {
    isDisabled: bool,
    isActive: bool,
    disabled: bool,
    children: node,
    onClick: func,
    style: object,
    className: string,
    theme: oneOf(['error', 'dark', 'action']),
    size: oneOf(['small', 'large']),
    isWide: bool,
    icon: string,
    iconPlacement: string,
    isProgress: bool,
    type: oneOf(['submit', 'button']),
    kind: oneOf(['fill', 'outline', 'link']),
    href: string,
    target: oneOf(['_blank']),
    linkComponent: oneOfType([object, element]),
    innerRef: object,
};
Button.defaultProps = {
    isDisabled: false,
    isActive: false,
    disabled: false,
    children: null,
    onClick: () => { },
    style: {},
    className: '',
    theme: 'action',
    size: 'large',
    isWide: false,
    icon: null,
    iconPlacement: 'left',
    isProgress: false,
    type: 'button',
    kind: 'fill',
    href: '',
    target: null,
    linkComponent: null,
    innerRef: null,
};
export default Button;
